import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {AiOutlineBank} from 'react-icons/ai'
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {rbacActions} from "../../../config/rbac/actions.ts";
import {ReloadRecordsButton} from "../buttons/ReloadRecordsButton.tsx";
import {DeleteRecordButton} from "../buttons/DeleteRecordButton.tsx";
import {AddRecordButton} from "../buttons/AddRecordButton.tsx";
import {FilterRecordsButton} from "../buttons/FilterRecordsButton.tsx";


// FNP-918: the index toolbar, composed here so what this module offers is
// readable in one place (§2).
//
// Order is [Reload, Filter] then Delete/Add — matching the sibling modules in
// this app and in console-app. Every element carries a stable `key`, which is
// the toolbar contract; `tools` is an ARRAY of buttons, never a hand-built
// <Group> (§2).
//
// Buttons are HIDDEN, not disabled, when RBAC forbids the action (§2, §10).
const useTools = (selectedIds: string[], onDeleteComplete?: () => void) => {

    const {allowedActions} = useVerifiedPermissions()

    const tools = [
        <ReloadRecordsButton key='reload'/>,
        <FilterRecordsButton key='filter'/>,
    ];

    if (allowedActions.includes(rbacActions.DeleteBankAccount)) {
        tools.push(<DeleteRecordButton key='delete' selectedIds={selectedIds} onDeleteComplete={onDeleteComplete}/>);
    }

    if (allowedActions.includes(rbacActions.CreateBankAccount)) {
        tools.push(<AddRecordButton key='add'/>);
    }

    return tools;
};

interface IndexPageHeaderProps {
    selectedIds?: string[];
    onDeleteComplete?: () => void;
}

export const IndexPageHeader = ({selectedIds = [], onDeleteComplete}: IndexPageHeaderProps) => {
    return (
        <SimplePageHeader
            title={I18n.get('Bank Accounts')}
            icon={<AiOutlineBank/>}
            tools={useTools(selectedIds, onDeleteComplete)}
        />
    );
};
